const qualificationConstants = {
	ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST:
		"Advanced Trainee Biodynamic Psychotherapist",
	BIODYNAMIC_MASSAGE_THERAPIST: "Biodynamic Massage Therapist",
	BIODYNAMIC_PSYCHOTHERAPIST: "Biodynamic Psychotherapist",
	SUPERVISOR: "Supervisor",
	SUPERVISOR_IN_TRAINING: "Supervisor in training",
	TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST: "Trainee Biodynamic Psychotherapist",
	TRAINEE_SUPERVISOR_NOT_UKCP_RECOGNISED:
		"Trainee Supervisor (not UKCP recognised)",
	TRAINEE_SUPERVISOR: "Trainee Supervisor"
};

const locationConstants = {
	IN_PERSON: "Works in-person",
	ONLINE: "Works Online",
	IN_PERSON_AND_ONLINE: "Works in-person and online"
};

const areaConstants = {
	LONDON: "London",
	EAST_SOUTH_EAST: "East/South East",
	MIDLANDS: "Midlands",
	SOUTH_WEST: "South West",
	INTERNATIONAL: "International",
	ONLINE: "Online"
};

// because of how therapists are now displayed by area (splice & push),
// the order below is reversed
// to move a therapist to the top of thier section, move them to the bottom of this array

const therapists = [
	{
		name: "Rowena Shingler",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["Surrey GU15", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.EAST_SOUTH_EAST, areaConstants.ONLINE],
		links: [
			"rowena.shingler@yahoo.co.uk",
			"https://www.rowenashinglerbiodynamictherapist.com"
		],
		imgUrl: "image0 (1).jpeg"
	},
	{
		name: "Sahar Talaat Elbassiony",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London South CR0", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["sahartalaat.psychotherapist@gmail.com"],
		imgUrl: "thumbnail_DSC_9754 copy - Copy.jpg"
	},
	{
		name: "Jonathan Dicker",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.TRAINEE_SUPERVISOR
		],
		location: ["London", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["Jonathan.biodynamic@gmail.com"],
		imgUrl: "image_6487327.JPG"
	},
	{
		name: "Liz Introno",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"London Central",
			"London South",
			"SE16",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["eintrono@gmail.com", "https://www.lizbodypsychotherapy.com"],
		imgUrl: "2B04204A-A622-48B7-B92F-FB5BFB99BC7C_1_201_a.jpeg"
	},
	{
		name: "Catherine Gehin",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["London West (W10)", locationConstants.IN_PERSON],
		links: [
			"massagetherapy.biodynamic@gmail.com",
			"https://www.nottinghilltherapyclinic.com"
		],
		area: [areaConstants.LONDON],
		imgUrl: "IMG_5743.png"
	},
	{
		name: "Françoise Lauwerie",
		qualifications: [
			qualificationConstants.ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"London South West (SW4 & SW8)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["francoise.lauwerie@laposte.net"],
		imgUrl: "DSC_2912.JPG"
	},
	{
		name: "Carlo Volpi",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["London North (N10)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["biodynamic.carlo@gmail.com", "https://www.soundstasis.com"],
		imgUrl: "IMG_1576.JPG"
	},
	{
		name: "Delene Gordon",
		qualifications: [
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["London East (E8/E10)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["delenedoes2@gmail.com"],
		imgUrl: "_ASH6787.jpg"
	},
	{
		name: "Maryam Abdollahzadeh",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London, Reading RG2", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON, areaConstants.SOUTH_WEST],
		links: ["abdoll.mar@gmail.com"],
		imgUrl: "IMG_1386.JPG"
	},
	{
		name: "Jessica Brown",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"trustinthelifeforce@gmail.com",
			"https://jessicabrownbiodynamic.my.canva.site/"
		],
		imgUrl: "unnamed (1).jpg"
	},
	{
		name: "Marleen Joseph",
		qualifications: [
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: [
			"London South West (SW19, SW20, SM3, SM4)",
			locationConstants.IN_PERSON
		],
		area: [areaConstants.LONDON],
		links: ["marljoe@hotmail.com"],
		imgUrl: "20161115_202328-1.jpg"
	},
	{
		name: "Barbara Hussong",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["South East (ME16)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.EAST_SOUTH_EAST, areaConstants.ONLINE],
		links: [
			"info@barbarahussong.co.uk",
			"https://www.barbarahussong.co.uk"
		],
		imgUrl: "Barbara Hussong March 2016.JPG"
	},
	{
		name: "Catherine Rees",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["South East (BN7)", locationConstants.IN_PERSON],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: [
			"Catherinemrees@ymail.com",
			"https://www.integrative-psychotherapist.org"
		],
		imgUrl: "catherine 1st.JPG"
	},
	{
		name: "Michelle Quoilin Lebrun",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["Surrey (GU2)", locationConstants.IN_PERSON],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: ["mquoilin_lebrun@yahoo.co.uk"],
		imgUrl: "45224ae9-48a6-43cf-b6ef-106de3e77cee.jpg"
	},
	{
		name: "Nicola Jephson Coates",
		qualifications: [
			qualificationConstants.ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"South East, Hindhead/Haslemere (GU26)",
			locationConstants.IN_PERSON
		],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: [
			"Najephsoncoates@gmail.com",
			"https://www.nicolabodypsychotherapy.com"
		],
		imgUrl: "IMG_20230621_165112_edit_370921201998086 2.jpg"
	},
	{
		name: "Steffany George",
		qualifications: [
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: [
			"Southend-on-Sea Essex",
			"Walthamstow, East London",
			locationConstants.IN_PERSON
		],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: ["segeorge7@gmail.com"],
		imgUrl: "image0 (3).jpeg"
	},
	{
		name: "Leslie Laine",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["South East (BN3) ", locationConstants.IN_PERSON],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: ["leslielaine@icloud.com ", "https://www.soul-arena.co.uk"],
		imgUrl: "IMG_1845.jpg"
	},
	{
		name: "Melita Pupsaite",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: [
			"Lichfield (WS13)",
			"Birmingham (B15)",
			locationConstants.IN_PERSON
		],
		area: [areaConstants.MIDLANDS],
		links: [
			"therapywithmelita@gmail.com",
			"https://www.melitapupsaite.co.uk"
		],
		imgUrl: "lsbp_melita2.jpg"
	},
	{
		name: "Alison Morse",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London (SW11)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["alisonmorse@btinternet.com"],
		imgUrl: "PHOTO-2021-02-14-19-36-13.jpg"
	},
	{
		name: "Ingrid Wienholts",
		qualifications: [
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["North Hampshire", locationConstants.IN_PERSON],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: ["https://www.ingridwienholts.com", "ingridwienholts@gmail.com"],
		imgUrl: "IMG-20220614-WA0009.jpg"
	},
	{
		name: "Toby Harrison",
		qualifications: [
			qualificationConstants.ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["Central and West London", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"tobes2002@hotmail.com",
			"https://www.AutonomicWellbeing.co.uk"
		],
		phone: "07894581996",
		imgUrl: "Toby_image1.jpg"
	},
	{
		name: "Gemma Ireland",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["South West (BA1)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.SOUTH_WEST, areaConstants.ONLINE],
		links: ["gemma3@talktalk.net"],
		imgUrl: "IMG_0070.JPG"
	},
	{
		name: "Gillie Gilbert",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["Dorset", locationConstants.ONLINE],
		area: [areaConstants.SOUTH_WEST, areaConstants.ONLINE],
		links: ["gilliegilbert@gmail.com"],
		imgUrl: "GillieG.jpg"
	},
	{
		name: "Nechoma Schwab",
		qualifications: [qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST],
		location: ["Israel", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.INTERNATIONAL, areaConstants.ONLINE],
		links: ["nechoma@mpowerlife.co.uk", "https://www.mpowerlife.co.uk"],
		imgUrl: "nechoma.jpg"
	},
	{
		name: "Terezinha Sell",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: [
			"Ireland (Galway City, Kinvara)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.INTERNATIONAL, areaConstants.ONLINE],
		links: ["te@tracht.ie", "https://www.tracht.ie"],
		imgUrl: "210629 Photo TS.jpg"
	},
	{
		name: "Olivia Lumley",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London SE5", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"olivialumleytherapies@gmail.com",
			"https://www.olivialumleytherapies.co.uk"
		],
		imgUrl: "2023-12-13 Olivia x Mandrake 0A6A9532.jpeg"
	},
	{
		name: "Hilary Price",
		qualifications: [qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST],
		location: [locationConstants.ONLINE],
		area: [areaConstants.ONLINE],
		links: [
			"hilary@biodynamictherapy.co.uk",
			"https://www.biodynamictherapy.co.uk"
		],
		imgUrl: "20230621_063246.jpg"
	},
	{
		name: "Brigitte Scott-Florek",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: [
			"Hampshire and East Dorset",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [
			areaConstants.EAST_SOUTH_EAST,
			areaConstants.SOUTH_WEST,
			areaConstants.ONLINE
		],
		links: [
			"Brigittescottflorek@gmail.com",
			"https://www.brigittescottflorek.co.uk"
		],
		imgUrl: "20230625_193332.jpg"
	},
	{
		name: "Claudia de Campos",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["London (NW3)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["claudia.campos@hotmail.co.uk"],
		imgUrl: "claudia.jpg"
	},
	{
		name: "Deborah Webb",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["South West (BA2)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.SOUTH_WEST, areaConstants.ONLINE],
		links: ["deborahwebb@talktalk.net"],
		imgUrl: "PHOTO-2023-11-21-17-42-40.jpg"
	},
	{
		name: "Anat Ben-Israel",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["USA, UK, Israel", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.INTERNATIONAL, areaConstants.ONLINE],
		links: ["anatbenisrael@gmail.com", "https://www.biodynamictherapy.net"],
		imgUrl: "Screen Shot 2022-08-31 at 23.55.20 2.jpeg"
	},
	{
		name: "Yigal Israel",
		qualifications: [qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST],
		location: ["Israel", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.INTERNATIONAL, areaConstants.ONLINE],
		links: ["yigalisr@gmail.com"],
		imgUrl: "Yigal Israel Photo June 2019 more light.jpg"
	},
	{
		name: "Sophie Paine",
		qualifications: [
			qualificationConstants.ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"Gloucestershire (GL6)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.SOUTH_WEST, areaConstants.ONLINE],
		links: ["sophie@wisebodies.com", "https://www.wisebodies.com"],
		imgUrl: "IMG_3574.jpg"
	},
	{
		name: "Julia Schaper",
		qualifications: [
			qualificationConstants.ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"London South (SW8)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["juliabiodynamictherapy@gmail.com"],
		imgUrl: "IMG_20230624_161406155.jpg"
	},
	{
		name: "Mélanie d’Ursel",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London West (W11)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["melanie@therapy.dursel.com"],
		imgUrl: "image0.jpeg"
	},
	{
		name: "Shlomit Eliashar",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR_IN_TRAINING
		],
		location: ["St Albans (AL4)", locationConstants.ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["shlomit0465@gmail.com"],
		imgUrl: "generic-user-icon-19.png"
	},
	{
		name: "Carlien van Heel",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: [
			"London North (N14)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["carlienvanheel@gmail.com"],
		imgUrl: "carlien.png"
	},
	{
		name: "Jacqualene Ryan",
		qualifications: [qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST],
		location: [
			"London, South West (TW10)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["jacqualeneryan@hotmail.com", "https://www.jacqualeneryan.com"],
		imgUrl: "cropped.png"
	},
	{
		name: "Anna Cromack",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"Worcestershire (WR9)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.MIDLANDS, areaConstants.ONLINE],
		links: ["anna.cromack@gmail.com", "https://www.annacromack.com"],
		imgUrl: "home 5.1.jpg"
	},
	{
		name: "Sarah Gay Rosella",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["South Devon (TQ9)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.SOUTH_WEST, areaConstants.ONLINE],
		links: [
			"Sarahgayrosella@gmail.com",
			"https://biodynamicbodypsychotherapy.com"
		],
		imgUrl: "sarah.jpg"
	},
	{
		name: "Miriam Salles",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["Eastbourne (BN21)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.EAST_SOUTH_EAST, areaConstants.ONLINE],
		links: ["miriamsalles2@gmail.com", "https://www.miriamsalles.net"],
		imgUrl: "miriam.jpg"
	},
	{
		name: "Peter Kendall",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London (SE19)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["pdjkendall@gmail.com", "https://www.bodyinsight.co.uk"],
		imgUrl: "generic-user-icon-19.png"
	},
	{
		name: "Ursula Deniflee",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.SUPERVISOR
		],
		location: ["London (SE1)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["u.deniflee@hotmail.com"],
		imgUrl: "generic-user-icon-19.png"
	},
	{
		name: "Angelo Frederick",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London, W10", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"originalspiritlondon@gmail.com",
			"https://originalspiritlondon.com "
		],
		imgUrl: "Me3.jpeg"
	},
	{
		name: "Emma Bond",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"London Central (W1), Suffolk (IP12)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [
			areaConstants.LONDON,
			areaConstants.EAST_SOUTH_EAST,
			areaConstants.ONLINE
		],
		links: [
			"emmabondconsultancy@hotmail.com",
			"https://emmabondbodypsychotherapist.com"
		],
		imgUrl: "emma bond.jpeg"
	},
	{
		name: "Marc Wallach",
		qualifications: [
			qualificationConstants.ADVANCED_TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["South West (Devon)", locationConstants.IN_PERSON],
		area: [areaConstants.SOUTH_WEST],
		links: [
			"marcwallach68@gmail.com",
			"https://marcbodypsychotherapy.com/"
		],
		imgUrl: "marc.jpeg"
	},
	{
		name: "Jessie Crawford",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["London", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON, areaConstants.ONLINE],
		links: ["contactjessiecrawford@gmail.com"],
		imgUrl: "jesse crawford.jpg"
	},
	{
		name: "Shaun Brooking",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London West (W1U)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"info@shaunbrookingcoaching.co.uk",
			"https://www.shaunbrookingcoaching.co.uk"
		],
		imgUrl: "Shaun-Brooking.webp"
	},
	{
		name: "Antoaneta Mandajieva",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London, South West", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["Antoanetawhale@hotmail.co.uk"],
		imgUrl: "image2.jpeg"
	},
	{
		name: "Tasha Payne",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London South", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["tash.biodynamictherapy@gmail.com"],
		imgUrl: "PXL_20230610_150928037~2.jpg"
	},
	{
		name: "Silvia Manzoni",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["London West (W6)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["man.silvia@gmail.com"],
		imgUrl: "image0 (2).jpeg"
	},
	{
		name: "Laura Jones",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.LONDON],
		links: ["lj@laurajones.co"],
		imgUrl: "Laura Jones.png"
	},
	{
		name: "Evodia Monica Martin",
		qualifications: [
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["London (SE1)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["Evodiamonica@gmail.com"],
		imgUrl: "Screenshot_20230626-084852_Instagram.jpg"
	},
	{
		name: "Jenny Allinson",
		qualifications: [
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST,
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST
		],
		location: ["Devon (TQ13)", locationConstants.IN_PERSON],
		area: [areaConstants.SOUTH_WEST],
		links: ["drjeta@gmail.com"],
		imgUrl: "drjeta.JPG"
	},
	{
		name: "Hannah Parker",
		qualifications: [
			qualificationConstants.BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: ["Bristol (BS8)", locationConstants.IN_PERSON_AND_ONLINE],
		area: [areaConstants.SOUTH_WEST, areaConstants.ONLINE],
		links: [
			"info@hannahparkertherapy.co.uk",
			"www.hannahparkertherapy.co.uk"
		],
		imgUrl: "hannah_parker.jpg"
	},
	{
		name: "Alex Mackintosh",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London (SE1)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["alex@unboundself.org", "https://www.unboundself.org"],
		imgUrl: "alex_mackintosh.jpg"
	},
	{
		name: "Bahareh Saremi",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["West London / Acton (W3)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: ["https://www.embodyd.co.uk/home", "Embodyd.bs@gmail.com"],
		imgUrl: "Bahareh.jpeg"
	},
	{
		name: "Lena (Magdalena) Bednarek",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: [
			"Woodford Green (IG8)",
			"Notting Hill (W8)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.LONDON],
		links: [
			"hello@magdalenabednarek.com",
			"https://www.magdalenabednarek.com"
		],
		imgUrl: "image.png"
	},
	{
		name: "Nicole Zimbler",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: [
			"Hemel Hampstead, Hertfordshire ",
			locationConstants.IN_PERSON
		],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: ["nicoleyotism@gmail.com"],
		imgUrl: "nicole_zimbler.jpg"
	},
	{
		name: "Ben Sheinwald",
		qualifications: [
			qualificationConstants.TRAINEE_BIODYNAMIC_PSYCHOTHERAPIST,
			qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST
		],
		location: [
			"Somerset (BA7) and Wiltshire (BA12)",
			locationConstants.IN_PERSON_AND_ONLINE
		],
		area: [areaConstants.SOUTH_WEST],
		links: ["https://www.bensheinwald.com", "bensheinwald@gmail.com"],
		imgUrl: "Ben_Sheinwald_head_shot_March_25.jpeg"
	},
	{
		name: "Deva Rachael Oliver",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["Frome, Somerset", locationConstants.IN_PERSON],
		area: [areaConstants.SOUTH_WEST],
		links: ["https://deva-soma.uk/", "socn@tutamail.com"],
		imgUrl: "41A2CDBC-EFB5-4B2F-9AF9-21C850835145.jpeg"
	},
	{
		name: "Laura-Maria Schober",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["Wanstead, East London", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"https://biodynamicmassagetherapy.co.uk/",
			"laura-maria.schober@hotmail.com"
		],
		phone: "07380637865",
		imgUrl: "Laura-Maria Schober.png"
	},
	{
		name: "Fanny Deroff",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["Suffolk", locationConstants.IN_PERSON],
		area: [areaConstants.EAST_SOUTH_EAST],
		links: [
			"https://www.thebiodynamicpractice.co.uk/",
			"https://albanyhealth.co.uk/",
			"fannyderoff@gmail.com"
		],
		phone: "07834732482",
		imgUrl: "fanny_deroff.jpeg"
	},
	{
		name: "Mujo Othol",
		qualifications: [qualificationConstants.BIODYNAMIC_MASSAGE_THERAPIST],
		location: ["London (South West)", locationConstants.IN_PERSON],
		area: [areaConstants.LONDON],
		links: [
			"https://www.mujo.studio/",
			"mujo.therapy@gmail.com"
		],
		imgUrl: "mujo_othol.JPG"
	}
];

export { areaConstants, qualificationConstants, therapists };
